<template>
	<div style="padding-bottom:60px">
		<div class="index-title">
			<p class="fl">{{ userName }}</p>
			<p class="fr">
				{{ $t('module.warehouse') }}：<span
					@click="popModule.flag = true"
					class="wms-info"
					>{{ activeWms ? activeWms.key : '' }}</span
				>
			</p>
		</div>

		<!-- <van-image :src="bgImg" /> -->
		<van-swipe :autoplay="5000">
			<van-swipe-item v-for="(image, index) in swipeImgList" :key="index">
				<van-image :src="image" />
			</van-swipe-item>
		</van-swipe>

		<div class="route-wrap">
			<template v-for="item in menuData">
				<p>{{ item.key }}</p>
				<van-grid :column-num="4">
					<van-grid-item
						v-for="child in item.next"
						:key="child.selfid"
						:icon="imgList[child.value] || 'photo-o'"
						:text="child.key"
						:to="{ name: child.value }"
					/>
				</van-grid>
			</template>
		</div>

		<van-tabbar v-model="activeMenu">
			<van-tabbar-item replace to="/index" icon="home-o">{{
				$t('module.index')
			}}</van-tabbar-item>
			<van-tabbar-item icon="orders-o">{{
				$t('module.excel')
			}}</van-tabbar-item>
			<van-tabbar-item replace to="/about" icon="contact">{{
				$t('module.about')
			}}</van-tabbar-item>
		</van-tabbar>

		<van-popup
			v-model="popModule.flag"
			position="bottom"
			:close-on-click-overlay="false"
		>
			<van-picker
				:title="$t('module.mainMenutitle')"
				show-toolbar
				:columns="wmsList"
				value-key="key"
				@confirm="onConfirm"
				@cancel="handleClose"
			/>
		</van-popup>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapGetters } from 'vuex';
import bgImg1 from '@/assets/img/u24.png';
import bgImg2 from '@/assets/img/u31.jpg';
import bgImg3 from '@/assets/img/u39.png';

export default {
	name: 'index',
	data() {
		return {
			userName: '',
			wmsList: [],
			activeWms: null,
			activeMenu: 0,
			popModule: {
				flag: false,
				defaultIndex: 0,
			},
			imgList: {},
			swipeImgList: [bgImg1, bgImg2, bgImg3],
			wms: '',
		};
	},
	computed: {
		...mapGetters(['menuType', 'menuData', 'btnData']),
	},
	methods: {
		esc() {},
		onClickRight() {
			this.$router.push('/about');
		},
		handleClose() {
			if (this.activeWms) {
				this.popModule.flag = false;
			} else {
				this.$notify({
					message: this.$SelectPlease('module.warehouse'),
					type: 'warning',
				});
				// this.$message.error(this.$SelectPlease('module.warehouse'))
			}
		},
		onConfirm(wms) {
			this.activeWms = wms;
			Cookies.set('wms', wms.value);
			this.$store.dispatch('setMenuData', []);
			this.getMenuList();
			this.getBtnPermissions();
			this.getWmsConfig();
			this.popModule.flag = false;
		},
		getMenuList() {
			if (this.menuData.length == 0) {
				this.http
					.get(`/rf/switchWmwhse/${this.activeWms.value}`)
					.then((res) => {
						if (res.status == '200' && res.data.returnCode == '200') {
							Cookies.set('wms', this.activeWms.value);
							this.$store.dispatch('setMenuData', res.data.list);
						}
					});
			}
		},
		getBtnPermissions() {
			if (this.btnData.length == 0) {
				this.http
					.get(`/getRFButtonPermissions/${this.activeWms.value}`)
					.then((res) => {
						if (res.status == '200' && res.data.returnCode == '200') {
							Cookies.set('wms', this.activeWms.value);
							this.$store.dispatch('setBtnData', res.data.list);
						}
					});
			}
		},
		getWmsConfig() {
			this.http
				.get('rf/codelkup/queryEffectiveByConfigkey/ScanWtUpper')
				.then((res) => {
					if (res.data.returnCode == 200) {
            Cookies.set('toUpperCase', res.data.bean);
					}
				});
		},
	},
	created() {
		this.wms = Cookies.get('wms');
		this.userName = JSON.parse(sessionStorage.getItem('user'));
		if (this.menuType == 'list') {
			this.$router.push({ name: 'mainmenu' });
		} else {
			this.wmsList = JSON.parse(sessionStorage.getItem('wmsList'));
			if (Cookies.get('wms')) {
				this.activeWms =
					this.wmsList.find((i) => i.value == Cookies.get('wms')) ||
					this.wmsList[0];
				this.getMenuList();
				this.getBtnPermissions();
				this.getWmsConfig();
			} else {
				// this.activeWms = this.wmsList[0];
				this.popModule.flag = true;
			}
		}
		const list = require.context('@/assets/img/menu', false, /\.png$/);
		list.keys().forEach((key) => {
			let name = key.replace('./', '').replace('.png', '');
			this.imgList[name] = require('@/assets/img/menu' +
				key.replace('./', '/'));
		});
	},
	mounted() {
		window.esc = this.esc;
	},
	activated() {
		if (Cookies.get('wms')) {
			this.activeWms =
				this.wmsList.find((i) => i.value == Cookies.get('wms')) ||
				this.wmsList[0];
			this.getMenuList();
			this.getBtnPermissions();
			this.getWmsConfig();
		} else {
			// this.activeWms = this.wmsList[0];
			this.popModule.flag = true;
		}
	},
};
</script>

<style lang="less" scoped>
.van-nav-bar {
	z-index: 999;
}
.van-swipe {
	width: 100%;
}

.route-wrap {
	p {
		padding: 1em;
		margin-top: 1em;
	}
}

.index-title {
	overflow: hidden;
}
.fl {
	float: left;
	line-height: 48px;
	padding: 0 1em;
	font-size: 14px;
}
.fr {
	float: right;
	line-height: 48px;
	padding: 0 1em;
	color: #aaaaaa;
	font-size: 14px;
	.wms-info {
		color: #000;
		font-size: 1.2em;
		text-decoration: underline;
	}
}
.van-grid-item {
	width: 25%;
}
::v-deep .van-grid-item__content {
	padding: 16px 0;
}
::v-deep .van-grid-item__text {
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align: center;
}
</style>
